
    <div class="container" [style.background-color]="selectedtemplateBgColor">
      <div  class="surveymsg"  *ngIf="isSurveyCompleted() == 'Completed'">
      Your Survey is expired
       </div>
      <div class="cardBox mb-20 mt-10">
        <div class="headingOfShowBox_two font_medium fs-14 fs_12ForMobile" [style.background-color]="selectedTemplateColorCode">
          <ion-row class="p-0">
            <ion-col size="12">
              <div class="phi-flex-wrap-center-space-between phi-gap-12">
                <div class="font_bold fs-14 fs_12ForMobile myMasterTableName">Employee Satisfaction Survey</div>
                <div class="w-sm-100 phi-flex-center ion-justify-content-between phi-gap-12">
                  <div class="verticle-center mr-20">
                    <img class="w30" src="././assets/icon/mail_white_icon.svg" alt="createEmailBody">
                    <p class="ml-5  myMasterEmail">{{loggedInUserEmail}}</p>
                  </div>
                  <div class="icon-container">
                    <span class="material-icons mr-10 fs-16 fs_14ForMobile">info</span>
                    <div class="tooltip">
                      <div class="info-popup">
                        <div class="p-20">
                          <h4 class="font_semibold">Instructions</h4>
                          <div class="mt-10 ml-20">
                            <ul *ngFor="let data of intructionList">
                              <li class="fs-12 text_gray">{{data}}</li>
                            </ul>
                          </div>
                          <div class="info-table mt-20">
                            <table>
                              <thead>
                                <tr>
                                  <th>Question type</th>
                                  <th>Rating</th>
                                  <th>Rating Definition</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let item of ratingList">
                                  <td>{{item.questionType}}</td>
                                  <td>{{item.rating}}</td>
                                  <td>{{item.ratingDefinition}}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ion-col>
          </ion-row>
        </div>
        <div class="p-10">
          <ion-row>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <ion-row>
                <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                  <div class="formLabelSemiBoldfs14 mb-5">Year</div>
                  
                  <mat-form-field class="w-90 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Year" [(ngModel)]="selectedYear"  [disabled]="isSurveyCompleted()">
                      <mat-option *ngFor="let item of yearsOfCompany"
                        [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
             
                <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                  <div class="formLabelSemiBoldfs14 mb-5">Survey</div>
                  <mat-form-field class="w-90 mat-height40 mat-input-style">
                    <mat-select placeholder="Select Survey" [(ngModel)]="selectedSurveyID"
                      (selectionChange)="isResponseSubmitted();getessByID()" [disabled]="isSurveyCompleted()">
                      <mat-option *ngFor="let item of essNamesListForUser" [value]="item.id">{{item.name}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </ion-col>
                <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                  <div class="formLabelSemiBoldfs14 mb-5">Start date</div>
                  <div class="w-90 inputBoxDisabled opacity5">
                    {{selectedSurveyStartDate | date:'dd-MM-yyyy'}}
                  </div>
                </ion-col>
                <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
                  <div class="formLabelSemiBoldfs14 mb-5">End date</div>
                  <div class="w-90 inputBoxDisabled opacity5">
                    {{selectedSurveyEndDate | date:'dd-MM-yyyy'}}
                  </div>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
        </div>
      </div>
 
      <div class="cardBox mb-30" *ngIf="selectedSurveyName!=null">
        <div class="p-20 mt-20">
          <div class="fs-24 fs_18ForMobile font_regular">{{selectedSurveyName}}</div>
          <div class="cardBox_two mt-20" *ngFor="let item of mySurveyQuestionList;let i =index">
            <div class="headingOfShowBox_two font_medium fs-14 fs_12ForMobile" [style.background-color]="selectedTemplateColorCode"></div>
            <div class="p-20">
              <div class="fs-14 fs_12ForMobile font_regular">{{item.question}}<span class="red-cl">&nbsp;*</span></div>
  
              <div class="mt-10" *ngIf="item.questionType == 'Open Ended'">
                <mat-form-field class="custom-input w-100  mat-input-style">
                  <textarea matInput [disabled]="isResponseSubmittedMySurvey || isSurveyCompleted() == 'Completed'" placeholder="Enter your Answer" rows="1"
                    maxlength="255" [(ngModel)]="item.answer"></textarea>
                </mat-form-field>
        
 
              </div>
              
              <div class="mt-10 myServayRatingBaseQuestionType" *ngIf="item.questionType == 'Rating Based'">
                <div class="ml-10" *ngFor="let data of ratingListOnRatingBased; let j = index; let isLast = last">
                  <div class="rating_btn w100 cp"
                    [ngClass]="{'selectedAnswer': item.answer == data.rating, 'disabled': isSurveyCompleted()=='Completed'}"
                    (click)="(isSurveyCompleted() != 'Completed') && onClickRating(item,data,i)">
                    {{ data.rating }}
                  </div>
                  <div class="text-center fs-12 mt-5 text_gray"
                  *ngIf="j==0 || isLast || item.answer == data.rating"
                 
                  matTooltipClass="custom-tooltip"
                  matTooltipPosition="above">
               {{ data?.ratingDefinition?.length > 15 
                   ? (data?.ratingDefinition | slice:0:15) + '...' 
                   : data?.ratingDefinition }}
             </div>
             
                </div>
              </div>
            </div>
          </div>
  
          <ion-row>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
              <div class="mt-20">
                <button
                  [ngClass]="{'disableBtn': isResponseSubmittedMySurvey || isSurveyCompleted() !== 'Active'}"
                  [disabled]="isResponseSubmittedMySurvey || isSurveyCompleted() !== 'Active'"
                  class="ess_Btn fs-14 fs_12ForMobile"
                  (click)="submitMySurveyResponse()"
                  [style.background-color]="selectedTemplateColorCode">
                  Submit
                </button>
                <label *ngIf="isResponseSubmittedMySurvey" class="fs-14 fs_12ForMobile font_regular ml-15">
                  Submitted on {{submissionDate | date: 'dd-MM-yyyy | hh:mm a'}}
                </label>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>
    </div>
 